import type { ServedAd } from "@/api/types";

/** Sources for this screen size: the phone version (or crop) on narrow screens. */
export function videoSources(ad: ServedAd, mobile: boolean) {
  const m = mobile && (ad.mobile_hls_url || ad.mobile_mp4_url_720);
  return {
    hls: (m ? ad.mobile_hls_url : ad.hls_url) || "",
    mp4: (m ? ad.mobile_mp4_url_720 : mobile ? ad.mp4_url_720 : ad.mp4_url_1080 || ad.mp4_url_720) || ad.video || "",
    poster: (m ? ad.mobile_poster_url : ad.poster_url) || ad.poster_url || ad.image || "",
  };
}
